// eslint-disable-next-line no-unused-vars
import config from '@/const/config';
import { easyPost } from './utils';

//  获取大搜结果
// eslint-disable-next-line import/prefer-default-export
export const legoData = easyPost('lego.bff.data');
// 上传用户反馈
export const uploadFeedBack = easyPost('upload.search.user.feedback');
